var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AnalyticsSubPage,{attrs:{"title":"Budget Analytics","icon":"wallet","css-class":"analytics-budget","default-label":"Budget","section-specs":_setup.sectionSpecs}},[_c(_setup.TrackMetrics,{ref:"trackRef"}),_c(_setup.BudgetMetrics,{ref:"budgetRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }